(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sweet-box"] && !Shopify.designMode) return;
  try {
    
  class SweetAdvantageBar extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-sweet-ab-item]'));
      this.activeIndex = 0;
      this.interval = null;
      this.mql = window.matchMedia('(max-width: 749px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.onMqlChange = () => this.syncRotation();
      this.mql.addEventListener('change', this.onMqlChange);
      this.syncRotation();
    }

    disconnectedCallback() {
      this.stop();
      this.mql.removeEventListener('change', this.onMqlChange);
    }

    syncRotation() {
      if (this.mql.matches && !this.reducedMotion && this.items.length > 1) {
        this.start();
      } else {
        this.stop();
      }
    }

    start() {
      if (this.interval) return;
      const ms = parseInt(this.dataset.interval, 10) || 4000;
      this.interval = setInterval(() => this.next(), ms);
    }

    stop() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }

    next() {
      this.items[this.activeIndex].classList.remove('is-active');
      this.activeIndex = (this.activeIndex + 1) % this.items.length;
      this.items[this.activeIndex].classList.add('is-active');
    }
  }

  if (!customElements.get('sweet-advantage-bar')) {
    customElements.define('sweet-advantage-bar', SweetAdvantageBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sweet-catdest-cta"] && !Shopify.designMode) return;
  try {
    
  class SweetCategoryNav extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-sweet-cn-track]');
      this.prevButton = this.querySelector('[data-sweet-cn-prev]');
      this.nextButton = this.querySelector('[data-sweet-cn-next]');

      if (!this.track) return;

      this.onPrevClick = () => this.scrollByCard(-1);
      this.onNextClick = () => this.scrollByCard(1);
      this.onTrackScroll = () => this.updateArrowState();

      this.prevButton?.addEventListener('click', this.onPrevClick);
      this.nextButton?.addEventListener('click', this.onNextClick);
      this.track.addEventListener('scroll', this.onTrackScroll, { passive: true });

      this.updateArrowState();
    }

    disconnectedCallback() {
      this.prevButton?.removeEventListener('click', this.onPrevClick);
      this.nextButton?.removeEventListener('click', this.onNextClick);
      this.track?.removeEventListener('scroll', this.onTrackScroll);
    }

    scrollByCard(direction) {
      const card = this.track.querySelector('[data-sweet-cn-card]');
      if (!card) return;

      const trackStyle = getComputedStyle(this.track);
      const gap = parseFloat(trackStyle.columnGap || trackStyle.gap || '0') || 0;
      const distance = (card.getBoundingClientRect().width + gap) * direction;

      this.track.scrollBy({ left: distance, behavior: 'smooth' });
    }

    updateArrowState() {
      if (!this.prevButton && !this.nextButton) return;

      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const maxScrollLeft = scrollWidth - clientWidth;

      this.prevButton?.toggleAttribute('disabled', scrollLeft <= 1);
      this.nextButton?.toggleAttribute('disabled', scrollLeft >= maxScrollLeft - 1);
    }
  }

  if (!customElements.get('sweet-category-nav')) {
    customElements.define('sweet-category-nav', SweetCategoryNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sweet-testimonials-carousel"] && !Shopify.designMode) return;
  try {
    
  class SweetTestimonialsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-sweet-tc-track]');
      this.prevButton = this.querySelector('[data-sweet-tc-prev]');
      this.nextButton = this.querySelector('[data-sweet-tc-next]');

      if (!this.track) return;

      this.onPrevClick = () => this.scrollByCard(-1);
      this.onNextClick = () => this.scrollByCard(1);
      this.onTrackScroll = () => this.updateArrowState();

      this.prevButton?.addEventListener('click', this.onPrevClick);
      this.nextButton?.addEventListener('click', this.onNextClick);
      this.track.addEventListener('scroll', this.onTrackScroll, { passive: true });

      this.updateArrowState();
    }

    disconnectedCallback() {
      this.prevButton?.removeEventListener('click', this.onPrevClick);
      this.nextButton?.removeEventListener('click', this.onNextClick);
      this.track?.removeEventListener('scroll', this.onTrackScroll);
    }

    scrollByCard(direction) {
      const card = this.track.querySelector('[data-sweet-tc-card]');
      if (!card) return;

      const trackStyle = getComputedStyle(this.track);
      const gap = parseFloat(trackStyle.columnGap || trackStyle.gap || '0') || 0;
      const distance = (card.getBoundingClientRect().width + gap) * direction;

      this.track.scrollBy({ left: distance, behavior: 'smooth' });
    }

    updateArrowState() {
      if (!this.prevButton && !this.nextButton) return;

      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const maxScrollLeft = scrollWidth - clientWidth;

      this.prevButton?.toggleAttribute('disabled', scrollLeft <= 1);
      this.nextButton?.toggleAttribute('disabled', scrollLeft >= maxScrollLeft - 1);
    }
  }

  if (!customElements.get('sweet-testimonials-carousel')) {
    customElements.define('sweet-testimonials-carousel', SweetTestimonialsCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
